<template >
  <div id="app"
       ref="scale">
    <tabs v-show="showTabs"
          :tabIndex="tabIndex" />
    <router-view />
    <bottom v-show="showBottom" />
  </div>
</template>

<script>
import tabs from './components/tabss.vue'
import bottom from './components/bottom.vue'
import "./utils/rem.js"

export default {
  name: 'App',
  components: {
    tabs,
    bottom
  },
  data () {
    return {
      scale: 1, // 初始缩放比例
      zoomFactor: 0.1, // 缩放因子，可以根据需要调整
      showTabs: true,
      showBottom: true,
      tabIndex: 0,
      isDocument: false
    }
  },
  methods: {
    setPath (routerUrl) {
      switch (routerUrl) {
        case '/':
          this.tabIndex = 0;
          break;
        case '/department':
          this.tabIndex = 1;
          break;
        case '/expert':
          this.tabIndex = 2;
          break;
        case '/device':
          this.tabIndex = 3;
          break;
        case '/honor':
          this.tabIndex = 4;
          break;
        case '/news':
          this.tabIndex = 5;
          break;
        case '/overview':
          this.tabIndex = 6;
          break;
        case '/recruit':
          this.tabIndex = 7;
          break;
        case '/contacUs':
          this.tabIndex = 8;
          break;

        case '/document':
          this.tabIndex = 0;
          this.isDocument = true;
          break;
        default:
      }
    }
  },
  mounted () {
    // this.setPath(this.$route.path);
    // const scaleEle = this.$refs.scale;
    // let scale = 1; // 初始缩放比例为1
    // scaleEle.addEventListener('wheel', (e) => {
    //   e.preventDefault(); // 阻止默认滚轮事件
    //   let delta = Math.max(-1, Math.min(1, e.deltaY)); // 获取滚轮方向
    //   scale += delta * 0.1; // 根据滚轮方向调整缩放比例
    //   scale = Math.max(0.1, Math.min(scale, 10)); // 设置缩放比例的最小值和最大值

    //   // 设置元素的缩放样式
    //   scaleEle.style.transform = `scale(${scale})`;
    // });
  },


  watch: {
    $route (to, from) {
      window.scrollTo(0, 0);
      this.setPath(to.path);
    }
  }
}
</script>

<style>
@import url("assets/css/common.css");
@import url("assets/css/index.css");
</style>
